import { Grant } from "../../types/Grant";
import { formatCurrency, getCurrencyType } from "../../utils/currencyFormatter";
import { VStack } from "../../components/utils";

interface BulkGrantOptionsValueCellProps {
  grant: Grant;
  showValueAtGrantToAdmin: boolean;
}

export function BulkGrantOptionsValueCell({
  grant,
  showValueAtGrantToAdmin,
}: BulkGrantOptionsValueCellProps) {
  const currency = getCurrencyType();

  if (showValueAtGrantToAdmin) {
    return (
      <VStack className="gap-0.5">
        <div className="font-medium text-sm cell-right">
          {grant.sharePrice != null
            ? formatCurrency(Number(grant.sharePrice), currency)
            : "—"}
        </div>
        <div className="text-xs text-gray-light cell-right">
          {grant.optionsGranted} options
        </div>
      </VStack>
    );
  }

  return (
    <VStack className="gap-0.5">
      <div className="font-medium text-sm cell-right">
        {grant.optionsGranted}
      </div>
      <div className="text-xs text-gray-light cell-right">
        {grant.sharePrice != null
          ? formatCurrency(Number(grant.sharePrice), currency)
          : "—"}
      </div>
    </VStack>
  );
}
